"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadJS = void 0;
const paypal_js_1 = require("@paypal/paypal-js");
const src_1 = require("..");
function loadJS(url, onLoad, options) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!(0, src_1.isJSAdded)(url)) {
            yield (0, paypal_js_1.loadCustomScript)({ url, attributes: options });
        }
        if ((0, src_1.isJSAdded)(url)) {
            onLoad && onLoad();
            return Promise.resolve();
        }
        else {
            return Promise.reject('Script tag not added');
        }
    });
}
exports.loadJS = loadJS;
